import { render } from "./PhaseDocuments.vue?vue&type=template&id=46a41bd4&ts=true"
import script from "./PhaseDocuments.vue?vue&type=script&lang=ts"
export * from "./PhaseDocuments.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__